import React from 'react';

const YouTube = ({ className = '' }: { className?: string }): JSX.Element => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24.237 17.042">
			<path
				d="M23.731 2.666A3.045 3.045 0 0 0 21.588.51C19.698 0 12.119 0 12.119 0S4.54 0 2.65.51A3.045 3.045 0 0 0 .506 2.666 31.947 31.947 0 0 0 0 8.538a31.947 31.947 0 0 0 .506 5.872 3 3 0 0 0 2.144 2.122c1.89.51 9.469.51 9.469.51s7.579 0 9.469-.51a3 3 0 0 0 2.143-2.122 31.947 31.947 0 0 0 .506-5.872 31.947 31.947 0 0 0-.506-5.872ZM9.64 12.142V4.934l6.335 3.6-6.335 3.6Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default YouTube;
